export default "__VITE_ASSET__DHOlJvFN__"